module.exports = __webpack_public_path__ + "assets/images/0e39274e5c297cc2f10aa25d7c3567b2.png";